var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserVerificationNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5331_8649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 124
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5331_8649)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5331_8649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7144 73.04C74.1741 73.04 84.2747 62.9681 84.2747 50.5438C84.2747 38.1195 74.1741 28.0476 61.7144 28.0476C49.2547 28.0476 39.1542 38.1195 39.1542 50.5438C39.1542 62.9681 49.2547 73.04 61.7144 73.04Z",
    fill: "url(#paint0_linear_5331_8649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.976 124H14.0238C14.0238 98.153 35.5007 77.2 61.9982 77.2C88.4958 77.2 109.976 98.153 109.976 124Z",
    fill: "url(#paint1_linear_5331_8649)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.7681 74.4L109.856 100.534H79.6799L94.7681 74.4Z",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1912 83.8533L95.9616 93.5493H93.5973L93.2645 83.8533H96.1912ZM93.1841 96.3138C93.1841 95.8905 93.3219 95.5365 93.5973 95.2518C93.8804 94.9594 94.2706 94.8132 94.768 94.8132C95.2577 94.8132 95.6441 94.9594 95.9272 95.2518C96.2103 95.5365 96.3518 95.8905 96.3518 96.3138C96.3518 96.7216 96.2103 97.0717 95.9272 97.3641C95.6441 97.6489 95.2577 97.7912 94.768 97.7912C94.2706 97.7912 93.8804 97.6489 93.5973 97.3641C93.3219 97.0717 93.1841 96.7216 93.1841 96.3138Z",
    fill: "#F5A342"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5331_8649",
    x: 3.8938,
    y: 19.9176,
    width: 116.212,
    height: 116.212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.065
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5331_8649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5331_8649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5331_8649",
    x1: 62.6013,
    y1: 72.0995,
    x2: 59.019,
    y2: 28.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5331_8649",
    x1: 63.886,
    y1: 123.022,
    x2: 62.0538,
    y2: 77.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerificationNeeded);
export default __webpack_public_path__ + "static/media/UserVerificationNeeded.e02df9a3faec09621a757dff73dd0663.svg";
export { ForwardRef as ReactComponent };